import React from 'react'
import { Link } from 'react-router-dom'
import { FaFacebook, FaTelegram, FaXTwitter } from 'react-icons/fa6'
import { FaDiscord } from 'react-icons/fa'
import Logo from "../../assets/images/ztp_logo.png";
import { useNavigate } from '../../hook/useNavigate'
import { Link as ScrollLink } from 'react-scroll'

const socialLinks = [
    {
        goTo: "https://t.me/ztpoker",
        icon: <FaTelegram />,
    },
    {
        goTo: "https://discord.gg/Y3ncVAeuqc",
        icon: <FaDiscord />,
    },
    {
        goTo: "https://x.com/ZeroTrustPoker",
        icon: <FaXTwitter />,
    },
    {
        goTo: "https://www.facebook.com/ZTPoker",
        icon: <FaFacebook />,
    },
];

const navLinks = [
    {
        goTo: "playnow",
        linkTitle: "Play Now",
    },
    {
        goTo: "features",
        linkTitle: "Features",
    },
    {
        goTo: "tokenomics",
        linkTitle: "Tokenomics",
    },
    {
        goTo: "roadmap",
        linkTitle: "Roadmap",
    },
    {
        goTo: "faq",
        linkTitle: "FAQ",
    },
    {
        goTo: "/whitepaper.pdf",
        linkTitle: "Whitepaper",
        external: true,
    },
];

const Footer = () => {
    const { navNewTab } = useNavigate()

    return (

        <footer className='footer-area'>
            <div className="container">
                <div className="footer-content row-gap-5">
                    <div className="col-lg-3" style={{ display: 'flex', alignItems: 'center' }}>
                        <div className="footer-content" style={{ display: 'flex', alignItems: 'center' }}>
                            <Link to="/">
                                <img className="logo" src={Logo} alt="Logo" />
                                {/* <img height={"52px"} src={logo} alt="logo" /> */}
                            </Link>
                        </div>
                    </div>
                    <div className="col-lg-7">
                        <div className="footer-widget">
                            <ul>
                                {navLinks.map((item, index) => (
                                    item.external ? (
                                        <a className={`nav-link`} href={item.goTo} target="_blank" rel="noopener noreferrer">{item.linkTitle}</a>) :
                                        (<li key={index} style={{ cursor: 'pointer' }} className={`nav-link`}>
                                            <ScrollLink
                                                activeClass="active"
                                                to={item.goTo}
                                                spy={true}
                                                smooth={true}
                                                offset={-70}
                                                duration={500}
                                            >
                                                {item.linkTitle}
                                            </ScrollLink>
                                        </li>
                                        )))}
                            </ul>
                        </div>
                    </div>
                    <div className="col-lg-2" style={{ display: 'flex', alignItems: 'center' }}>
                        <div className="footer-widget">
                            <div style={{ display: 'flex' }}>
                                {socialLinks.map((item, index) => (
                                    <div key={index} className="nav-social" style={{ cursor: 'pointer' }} onClick={() => navNewTab(item.goTo)}>
                                        {item.icon}
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </footer>

    )
}

export default Footer